import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { criteriaOperatorsMap, advancedComparisonOperators } from '../../../../../containers/base-filter-bar-container/criteria-operators';

// Create a custom version of advancedComparisonOperators without the "Not Equal To" operator
const enhancedReturnsComparisonOperators = advancedComparisonOperators.filter((operator) => operator.id !== 'notEqualTo');

// Create a custom CriteriaOperatorsMap for enhanced returns
const EnhancedReturnsCriteriaOperatorsMap = {
  ...criteriaOperatorsMap,
  // Override the TYPE_CURRENCY_COMPARISON to use the filtered operators
  [OptionFormTypes.TYPE_CURRENCY_COMPARISON]: enhancedReturnsComparisonOperators,
};

export default EnhancedReturnsCriteriaOperatorsMap;
